module.exports = __webpack_public_path__ + "svg/context-dark.svg?6eb7da8e3d9c891e9c37a5195fd4a868";